export default __webpack_public_path__ + "static/media/home-startup-about-img.2f9331e1.jpg";